import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo, ReactNode } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { DefaultTheme, useTheme } from 'styled-components';

const HeaderButton: FC<{
  text?: string;
  color?: string | ((theme: DefaultTheme) => string);
  style?: StyleProp<ViewStyle>;
  scale: number;
  onPress?: () => void;
  children?: ReactNode;
}> = memo(({ style, text, color, scale, onPress, children }) => {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  return (
    <TouchableOpacity
      css={`
        height: ${Math.min(
          rpx(40),
          Math.max(rpx(28), Math.round(28 * scale)),
        )}px;
        border-radius: ${Math.max(rpx(4), Math.round(4 * scale))}px;
        border-width: 1px;
        border-color: ${theme.inspection.siteGrid.headerButtonBorderColor};
        background-color: ${theme.inspection.siteGrid.headerButtonColor};
        padding: ${Math.min(rpx(5), Math.max(rpx(3), Math.round(3 * scale)))}px
          ${Math.round(5 * scale)}px;
        margin-left: ${rpx(5)}px;
        align-items: center;
        justify-content: center;
      `}
      style={style}
      onPress={onPress}
    >
      {text ? (
        <Typography.Label
          color={p =>
            typeof color === 'function' ? color(p) : color ?? p.link
          }
          size={Math.min(rpx(20), Math.max(rpx(13), Math.round(13 * scale)))}
          regular
        >
          {text}
        </Typography.Label>
      ) : null}
      {children}
    </TouchableOpacity>
  );
});

export const InspectionSiteGridHeader = memo(
  ({
    groupId,
    name,
    width,
    hasMore,
    onMorePress,
  }: // onBatchNormalPress,
  {
    groupId: string;
    name: string;
    width: number;
    hasMore: boolean;
    onMorePress?: (groupId: string) => void;
    onBatchNormalPress?: (groupId: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const scale = width / 4 / 107;
    const theme = useTheme();
    return (
      <View
        css={`
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: ${Math.min(rpx(80), Math.max(52, 52 * scale))}px;
          padding: 0 ${Math.max(rpx(15), 15 * scale)}px;
          background-color: ${theme.inspection.siteGrid.headerBgColor};
        `}
      >
        <Typography.Label
          size={Math.min(rpx(30), Math.max(rpx(20), Math.round(20 * scale)))}
          lineHeight={Math.min(
            rpx(32),
            Math.max(rpx(28), Math.round(28 * scale)),
          )}
          regular
          css={`
            flex: 1;
          `}
          color={p => p.inspection.siteGrid.headerTextColor}
        >
          {name}
        </Typography.Label>
        {hasMore && (
          <HeaderButton
            text="更多"
            scale={scale}
            onPress={() => onMorePress?.(groupId)}
          />
        )}
      </View>
    );
  },
);
